export const isFieldValid = (value: string | number | null | undefined): boolean => {
	return (
		(typeof value === 'string' && value.trim() !== '') ||
		(typeof value === 'number' && (!isNaN(value) || value > 0)) ||
		(Array.isArray(value) && value.length > 0)
	);
};

export const isFormValid = (state: object): boolean => {
	const values = Object.values(state);

	return values.every((value) => isFieldValid(value));
};
